import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import FuelLevyListTable from './FuelLevyRateTable';
const FuelLevyListPage = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(FuelLevyListTable, {}) }));
};
export default FuelLevyListPage;
